exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".react-datepicker {\n  transform: scale(1.6);\n}", ""]);

// exports
